export default "__VITE_ASSET__DxpqSMsp__"